import { gql } from "@apollo/client";

export const CREATE_EXPORT_FILE = gql`
  mutation CreateExport($exportType: String!, $entityId: String) {
    createExport(exportType: $exportType, entityId: $entityId) {
      id
    }
  }
`;

export default {
  CREATE_EXPORT_FILE,
};
